import { useState, useEffect } from "react";
import { api } from "@/lib/apiClient";
import { useAuth } from "@/context/AuthContext";
import { ReviewDialog } from "@/components/support/ReviewDialog";
import { fmtDuration, fmtDate } from "@/lib/supportApi";
import { toast } from "sonner";

export default function NeedsReview() {
  const { currentOrgId } = useAuth();
  const [rows, setRows] = useState([]);
  const [sel, setSel] = useState(null);

  const load = () => { if (currentOrgId) api.get(`/support/sessions/needs-review?org_id=${currentOrgId}`).then((r) => setRows(r.data)).catch(() => {}); };
  useEffect(load, [currentOrgId]);

  const dismiss = async (s) => {
    try { await api.post(`/support/sessions/${s.session_id}/dismiss`, { org_id: currentOrgId }); toast("Dismissed"); load(); }
    catch { toast.error("Failed"); }
  };

  return (
    <div className="space-y-4" data-testid="needs-review-page">
      <h1 className="font-heading text-xl font-bold tracking-tight">Remote sessions awaiting review</h1>
      <p className="text-sm text-zinc-500">Connection time is recorded automatically. Reviewing does not make time billable.</p>
      <div className="rounded-xl border border-white/10 bg-zinc-900/60 divide-y divide-white/5">
        {rows.map((s) => (
          <div key={s.session_id} data-testid={`review-row-${s.session_id}`} className="flex items-center justify-between px-4 py-3 gap-3">
            <div className="min-w-0">
              <div className="text-sm font-medium truncate">{s.machine_name} · {s.customer_name || "— no customer —"}</div>
              <div className="text-xs text-zinc-500">{fmtDate(s.ended_at)} · connection {fmtDuration(s.duration_seconds)} · reconnects {s.reconnect_count}</div>
            </div>
            <div className="flex items-center gap-2 shrink-0">
              <button data-testid={`dismiss-${s.session_id}`} onClick={() => dismiss(s)} className="text-xs text-zinc-400 hover:text-white px-2 py-1.5">Dismiss</button>
              <button data-testid={`open-review-${s.session_id}`} onClick={() => setSel(s)} className="text-xs font-semibold px-3 py-1.5 rounded-full bg-blue-600 hover:bg-blue-500">Review</button>
            </div>
          </div>
        ))}
        {rows.length === 0 && <div className="p-8 text-center text-sm text-zinc-500">Nothing to review 🎉</div>}
      </div>
      <ReviewDialog open={!!sel} onOpenChange={(o) => !o && setSel(null)} session={sel} onReviewed={load} />
    </div>
  );
}
